<template>
  <div id="country">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>人员管理&nbsp;/&nbsp;乡厨管理</span>
      </div>
      <div style="display: flex; flex-wrap: wrap; align-items: center">
        <Week @childFn="parentFn"></Week>
        <el-input
          class="elinputs"
          v-model="userName"
          placeholder="姓名"
        ></el-input>
        <el-input
          class="elinputs"
          v-model="poper"
          placeholder="手机号"
        ></el-input>
        <el-select
          v-model="healthy"
          placeholder="健康证状态"
          class="elinputs"
        >
          <el-option
            v-for="item in healthyList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <!-- 培训考核状态筛选 -->
        <el-select
          v-model="examState"
          placeholder="考核状态"
          class="elinputs"
        >
          <el-option
            v-for="item in examStateList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="examine"
          placeholder="审核状态"
          class="elinputs"
        >
          <el-option
            v-for="item in examineList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select v-model="stat" placeholder="启用状态" class="elinputs">
          <el-option
            v-for="item in statList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="zctime"
          type="daterange"
          value-format="yyyy-MM-dd"
          @blur="time"
          range-separator="至"
          start-placeholder="注册开始日期"
          end-placeholder="注册结束日期"
        >
        </el-date-picker>
        <el-button
          style="margin-left: 10px"
          type="primary"
          element-loading-text="加载中..."
          element-loading-background="rgba(0, 0, 0, 0.4)"
          v-loading.fullscreen.lock="fullscreenLoading"
          @click="query"
          >查询</el-button
        >
        <el-button type="info" @click="reset">重置</el-button>
      </div>
      <div class="tit">
        <span
          >总计：<i style="color: #11A983; font-weight: 600">{{ listnum }}</i>
          条</span
        >
        <Xlsx :name="formname"></Xlsx>
      </div>
      <el-table
        :data="tableData"
        id="exportTab"
        border
        stripe
        :sort-method="sortChange1"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" width="80" :index="1">
        </el-table-column>
        <el-table-column label="头像" width="100">
          <template slot-scope="scope">
            <!-- <img :src="scope.healthPhoto" alt=""> -->
            <img
              v-if="scope.row.photo == ''"
              class="sfzimg"
              src="../../assets/img/user_logo.png"
              alt=""
            />
            <viewer v-else>
              <img class="sfzimg" :src="imgUrl + scope.row.photo" />
            </viewer>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="姓名" width="120">
        </el-table-column>
        <el-table-column label="性别" width="80">
          <template slot-scope="scope">
            <p>{{scope.row.userSex == '' ? '未知' : scope.row.userSex}}</p>
          </template>
        </el-table-column>
        <el-table-column label="年龄" sortable width="100">
          <template slot-scope="scope">
            <p>{{scope.row.age == 72 ? '未知' : scope.row.age}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="telMobile" label="手机号" sortable width="120">
        </el-table-column>
        <el-table-column min-width="260" label="所属地区">
          <template slot-scope="scope">
            <p>
              {{ scope.row.city }} {{ scope.row.district }}
              {{ scope.row.town }} {{ scope.row.village }}
              {{ scope.row.address }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="星级评分" width="120">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.ruralKitchenGrade">{{ scope.row.ruralKitchenGrade.grades }}</p>
            <p v-else>-</p>
          </template>
        </el-table-column>
        <el-table-column label="相关报备次数" width="120">
          <template slot-scope="scope">
            <p class="boldfont">{{ scope.row.reportTotal }}</p>
          </template>
        </el-table-column>
        <el-table-column label="相关办宴次数" width="120">
          <template slot-scope="scope">
            <p class="boldfont">{{ scope.row.dinnerTotal }}</p>
          </template>
        </el-table-column>
        <el-table-column label="燃料类型" width="160">
          <template slot-scope="scope">
            <p v-if="scope.row.fuelType == null || scope.row.fuelType == ''">无</p>
            <p v-else>{{scope.row.fuelType}}</p>
          </template>
        </el-table-column>
        <el-table-column label="健康证状态" width="140">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.hstate == 1" style="color: #67c23a">正常</p>
            <p
              class="boldfont"
              v-if="scope.row.hstate == 3"
              style="color: #f56c6c"
            >
              过期
            </p>
            <p
              class="boldfont"
              v-if="scope.row.hstate == 2"
              style="color: #e6a23c"
            >
              即将过期
            </p>
          </template>
        </el-table-column>
        <el-table-column label="健康证过期时间" width="160">
          <template slot-scope="scope">
            <p>{{ scope.row.healthPhotoValidity }}</p>
          </template>
        </el-table-column>
        <el-table-column label="考核状态" width="120">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.examState == 2" style="color: #67c23a">已考核</p>
            <p class="boldfont" v-if="scope.row.examState == 1" style="color: #f56c6c">未考核</p>
          </template>
        </el-table-column>
        <el-table-column label="最高得分" width="120">
          <template slot-scope="scope">
            <p class="boldfont">{{ scope.row.maxFraction }}</p>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="120">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.checkState == 1" style="color: #e6a23c">
              待审核
            </p>
            <p class="boldfont" v-if="scope.row.checkState == 2" style="color: #67c23a">通过</p>
            <p class="boldfont" v-if="scope.row.checkState == 3" style="color: #f56c6c">
              不通过
            </p>
          </template>
        </el-table-column>
        <el-table-column label="启用状态" width="100">
          <template slot-scope="scope">
            <p class="boldfont" v-if="scope.row.state == 1" style="color: #67c23a">启用</p>
            <p class="boldfont" v-if="scope.row.state == 2" style="color: #f56c6c">禁用</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="注册时间"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          width="180"
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="handleEdit(scope.row, 'xc:update')"
              ><i class="el-icon-edit"></i> 编辑</el-button
            >
            <el-button
              size="mini"
              :class="scope.row.state == '1' ? 'f56' : 'c23'"
              @click="prohibit(1, scope.row, 'xc:prohibit')"
              ><i class="el-icon-remove-outline"></i
              ><span v-if="scope.row.state == 1">禁用</span
              ><span v-else>启用</span></el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="prohibit(2, scope.row, 'xc:delete')"
              ><i class="el-icon-delete"></i> 删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <span
          >共 <i class="pagingNum">{{ listnum }}</i> 条</span
        >
        <Paging :gopage="listnum" @pag="pag"></Paging>
      </div>
    </el-card>
    <el-dialog
      title="乡厨管理/编辑"
      :visible.sync="dialogFormVisible"
      class="myxx"
      width="60%"
    >
      <div style="display: flex; justify-content: space-between">
        <div style="width: 70%" class="leftcont">
          <p>* 登录账号</p>
          <el-input
            placeholder="请输入登录账号"
            :disabled="true"
            v-model="details.telMobile"
            clearable
          >
          </el-input>
          <p>* 登录密码</p>
          <el-input
            placeholder="请输入登录密码"
            v-model="details.password"
            clearable
          >
          </el-input>
          <p>* 姓名</p>
          <el-input
            placeholder="请输入姓名"
            :disabled="true"
            v-model="details.userName"
            clearable
          >
          </el-input>
          <p>* 星级评分</p>
          <el-input-number class="number-input" v-model="details.grades" :precision="1" :step="0.1" :min="0.1" :max="5.0"></el-input-number>
          <p>* 合格次数</p>
          <el-input
            placeholder="请输入姓名"
            :disabled="true"
            v-model="details.qualifiedTotal"
            clearable
          >
          </el-input>
          <p>* 健康证过期时间</p>
          <el-input
            placeholder="健康状态"
            :disabled="true"
            v-model="details.healthPhotoValidity"
            clearable
          >
          </el-input>
          <p>* 健康证状态</p>
          <el-input
            placeholder="健康状态"
            :disabled="true"
            v-model="details.hstates"
            clearable
          >
          </el-input>
          <p>* 办宴次数</p>
          <el-input
            placeholder="请输入办宴次数"
            :disabled="true"
            v-model="details.banquetAmount"
            clearable
          >
          </el-input>
          <p>* 办宴桌数</p>
          <el-input
            placeholder="请输入办宴桌数"
            :disabled="true"
            v-model="details.banquetTables"
            clearable
          >
          </el-input>
          <p>* 服务人次</p>
          <el-input
            placeholder="请输入服务人次"
            :disabled="true"
            v-model="details.banquetPeopleTimes"
            clearable
          >
          </el-input>
          <p>* 接受委托率</p>
          <el-input
            placeholder="请输入接受委托率"
            :disabled="true"
            v-model="details.acceptRate"
            clearable
          >
          </el-input>
          <p>* 被驳回次数</p>
          <el-input
            placeholder="请输入姓名"
            :disabled="true"
            v-model="details.rejectTotal"
            clearable
          >
          </el-input>
          <p>* 检查不通过次数</p>
          <el-input
            placeholder="请输入姓名"
            :disabled="true"
            v-model="details.notpassotal"
            clearable
          >
          </el-input>
          <p>* 手机号</p>
          <el-input
            placeholder="请输入手机号"
            :disabled="true"
            v-model="details.telMobile"
            clearable
          >
          </el-input>
          <p>* 身份证号码</p>
          <el-input
            placeholder="请输入身份证号码"
            :disabled="true"
            v-model="details.idCard"
            clearable
          >
          </el-input>
          <p>* 性别</p>
          <el-input
            placeholder="请输入性别"
            :disabled="true"
            v-model="details.userSex"
            clearable
          >
          </el-input>
          <p>* 身份证有效时间</p>
          <el-input
            placeholder="请输入身份证有效时间"
            :disabled="true"
            v-model="details.idCardValidity"
            clearable
          >
          </el-input>
          <p>* 所属地区</p>
          <el-input
            :placeholder="
              details.city +
              ' ' +
              details.district +
              ' ' +
              details.town +
              ' ' +
              details.village
            "
            :disabled="true"
            clearable
          >
          </el-input>
          <p>* 详细地址</p>
          <el-input
            placeholder="请输入详细地址"
            v-model="details.address"
            clearable
          >
          </el-input>
          <p>个人简介</p>
          <el-input
            placeholder="请输入乡厨简介"
            v-model="details.introduce"
            clearable
          >
          </el-input>
          <!--<div style="border: 1px solid #ccc;">-->
          <!--  <Toolbar-->
          <!--    style="border-bottom: 1px solid #ccc"-->
          <!--    :editor="editor"-->
          <!--    :defaultConfig="toolbarConfig"-->
          <!--    :mode="mode"-->
          <!--  />-->
          <!--  <Editor-->
          <!--    style="height: 500px; overflow-y: hidden;"-->
          <!--    v-model="details.introduce"-->
          <!--    :defaultConfig="editorConfig"-->
          <!--    :mode="mode"-->
          <!--    @onCreated="onCreated"-->
          <!--  />-->
          <!--</div>-->
        </div>
        <div style="width: 26%">
          <div class="upload1" v-if="details.frontPhoto != ''">
            <viewer>
              <img :src="imgUrl + details.frontPhoto" style="width: 100%" />
            </viewer>
          </div>
          <div class="upload1" style="margin-top: 20px" v-if="details.backPhoto != ''">
            <viewer>
              <img :src="imgUrl + details.backPhoto" style="width: 100%" />
            </viewer>
          </div>
          <div class="upload1" style="margin-top: 20px" v-if="details.healthPhoto != ''">
            <viewer>
              <img :src="imgUrl + details.healthPhoto" style="width: 100%" />
            </viewer>
          </div>
          <div class="upload1" style="margin-top: 20px" v-if="details.pollcardPhoto != ''">
            <viewer>
              <img :src="imgUrl + details.pollcardPhoto" style="width: 100%" />
            </viewer>
          </div>
          <div class="upload1" style="margin-top: 20px" v-if="details.policyPhoto != ''">
            <viewer>
              <img :src="imgUrl + details.policyPhoto" style="width: 100%" />
            </viewer>
          </div>
          <div class="upload1" style="margin-top: 20px" v-if="details.trainingPhote != ''">
            <viewer>
              <img :src="imgUrl + details.trainingPhote" style="width: 100%" />
            </viewer>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button class="newbtn" @click="gxdata">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Week from "@/components/Week";
import Xlsx from "@/components/Xlsx";
import Paging from "@/components/Paging";

export default {
  name: "country",
  components: {
    Week,
    Xlsx,
    Paging
  },
  data() {
    return {
      examine: "", //审核
      examineList: [
        { value: 1, name: "待审核" },
        { value: 2, name: "通过" },
        { value: 3, name: "未通过" },
      ],
      healthy: "", //健康状态
      healthyList: [
        { value: 1, name: "正常" },
        { value: 2, name: "即将过期" },
        { value: 3, name: "过期" },
      ],
      examState: "", //考核状态
      examStateList: [
        { value: 1, name: "未考核" },
        { value: 2, name: "已考核" },
      ],

      stat: "",
      statList: [
        { value: 1, name: "启用" },
        { value: 2, name: "禁用" },
      ],
      poper: "",
      userName: "",
      zctime: "",
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      listnum: 0,
      dialogFormVisible: false,
      userdata: {},
      details: {},
      pwd: "",
      areaId: "",
      btn: [],
      formname: JSON.stringify({ name: "乡厨管理人员表", hint: "xc:export" }),
      fullscreenLoading: true,
      imgUrl: this.$Public.imgUrl,
      editor: null,
      toolbarConfig: { },
      editorConfig: { placeholder: '请输入' },
      mode: 'default', // or 'simple'
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.load();
  },
  computed: {
    data() {
      return this.tableData;
    },
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    pag(val) {
      this.pageNum = val.pageNum;
      this.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.load();
    },
    load() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        adminAreasId: userdata.areasId,
        areaId: this.areaId,
        checkState: this.examine,
        examState: this.examState,
        startTime: this.zctime[0],
        endTime: this.zctime[1],
        healthStatus: this.healthy,
        state: this.stat,
        telMobile: this.poper,
        userName: this.userName,
      });
      this.$axios
        .post(`/api-r/user/getRuralKitchenList`, data, {
          headers: { accessToken: userdata.token },
        })
        .then((res) => {
          // console.log(res,'角色列表')
          if (res.data.success) {
            this.fullscreenLoading = false;
            this.$set(this, "tableData", res.data.pageInfo.list);
            this.$set(this, "listnum", res.data.pageInfo.total);
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    parentFn(i) {
      this.areaId = i.id;
    },
    // 查询
    query() {
      this.pageNum = 1;
      this.fullscreenLoading = true;
      this.load();
    },
    time() {
      console.log(this.zctime);
    },
    sortChange1(a, b) {
      console.log(a, b);
    },
    getParams(params) {
      const {grades,banquetAmount,banquetTables,banquetPeopleTimes,acceptRate } = params.ruralKitchenGrade || {}
      return {
        ...params,
        grades,
        banquetAmount,
        banquetTables,
        banquetPeopleTimes,
        acceptRate
      }
    },
    handleEdit(row, hint) {

      if (this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.dialogFormVisible = true;
      this.$set(this, "details", {...this.getParams(row)});
      // this.$router.push({  //核心语句
      //     name:'countrydet',
      // })
      for (var item in this.healthyList) {
        this.healthyList[item];
        if (row.hstate == this.healthyList[item].value) {
          this.details.hstates = this.healthyList[item].name;
        }
      }
    },
    gxdata() {
      // let data = this.$qs.stringify({
      //     userType:2,
      //     userId:this.details.userId,
      //     password:this.details.password,
      //     address:this.details.address
      // })

      this.$axios
        .post(`/api-r/user/updateUser`, this.$qs.stringify(
          {
            ...this.details,
            banquetAmount:undefined,
            banquetTables:undefined,
            banquetPeopleTimes:undefined,
            acceptRate:undefined
          }), {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.load()
            this.dialogFormVisible = false;
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    // 禁用用户
    prohibit(i, row, hint) {
      if (this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      if (i == 1) {
        this.$axios
          .post(
            `/api-r/user/prohibitUser/${row.userId}`,
            {},
            { headers: { accessToken: this.userdata.token } }
          )
          .then((res) => {
            if (res.data.success == true) {
              if (row.state == 1) {
                this.$message({
                  type: "success",
                  message: "禁用成功",
                });
              } else if (row.state == 2) {
                this.$message({
                  type: "success",
                  message: "启用成功",
                });
              }
              this.load();
            } else {
              alert(res.data.msg);
            }
          });
      } else if (i == 2) {
        this.$confirm("此操作将删除该管理, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios
              .post(
                `/api-r/user/deleteUser/${row.userId}`,
                {},
                { headers: { accessToken: this.userdata.token } }
              )
              .then((res) => {
                if (res.data.success == true) {
                  this.$message({
                    type: "success",
                    message: res.data.msg,
                  });
                  this.load();
                } else {
                  alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            return;
          });
      }
    },
    reset() {
      this.$router.push("/refresh");
    },
  },
};
</script>
<style>
#country .el-input__inner {
  margin: 10px 0;
}
#country .el-pagination__sizes .el-input__inner {
  margin: 0;
}
/* #country .el-select{margin: 0 8px;} */
#country .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
#country .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#country .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#country .myxx .number-input{
  margin: 10px 0 20px 0;
}
#country .myxx .number-input .el-input__inner {
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;
}

#country .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}

.el-input.is-disabled .el-input__inner {
  background: none !important;
}
</style>
<style scoped lang="scss">
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
  align-items: center;
}
.sfzimg {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.upimg {
  width: 100%;
  text-align: center;
  background-color: #dcdcdc;
  line-height: 30px;
}
.upload1 {
  border: 1px solid #d2d2d2;
  padding: 6px;
}
.leftcont p {
  margin-bottom: 6px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.newbtn {
  background-color: #11A983;
  color: #fff;
}
</style>
